export default function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return getIn(nonNullGetFormState(state), form + ".asyncErrors");
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../redux-form/es/selectors/getFormAsyncErrors.js
// module id = 1351
// module chunks = 25